import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable ,Component, OnDestroy, ViewChild } from '@angular/core';
import { BehaviorSubject, catchError, Observable } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService  {
  private user = new BehaviorSubject(null);
  private subMenus = new BehaviorSubject(null);
  private datePicker: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private date: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private smallScreenMenuState: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  private nemtCodes = new BehaviorSubject(null);
  private unreadNotificationCount = new BehaviorSubject<number>(0);

  constructor(private http : HttpClient) { }

  getUser(): Observable<any> {
    return this.user.asObservable();
  }

  saveUser(user: any) {
    this.user.next(user);
  }

  getSubMenus() {
    return this.subMenus.asObservable();
  }

  saveSubMenus(subMenus: any) {
    this.subMenus.next(subMenus);
  }

  toggleDatePicker(bool: any){
    this.datePicker.next(bool);
  }

  getDatePickerSate(){
    return this.datePicker.asObservable();
  }

  setDate(date: any){
    this.date.next(date);
  }

  getDate(){
    return this.date.asObservable();
  }

  getSmallScreenMenuState(): Observable<any> {
    return this.smallScreenMenuState.asObservable();
  }

  setSmallScreenMenuState(b: any) {
    this.smallScreenMenuState.next(b);
  }

  getNemtCodes(): Observable<any> {
    return this.nemtCodes.asObservable();
  }

  saveNemtCodes(data: any) {
    this.nemtCodes.next(data);
  }

  getNotifications(queryParam?:any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.NOTIFICATIONS_URL, {params})
      .pipe(catchError(errorHandl));
  }

  markNotificationAsRead(id: string): Observable<any> {
    return this.http.patch(urls.API_URL + urls.NOTIFICATIONS_URL + `/${id}`, { isRead: true })
      .pipe(catchError(errorHandl));
  }

  markAllNotificationsAsRead(): Observable<any> {
    return this.http.patch(urls.API_URL + urls.NOTIFICATIONS_MARK_ALL_READ, {})
      .pipe(catchError(errorHandl));
  }

  getUnreadNotificationCount(): Observable<number> {
    return this.unreadNotificationCount.asObservable();
  }

  setUnreadNotificationCount(count: number) {
    this.unreadNotificationCount.next(Math.max(0, count || 0));
  }

  incrementUnreadNotificationCount(amount = 1) {
    this.setUnreadNotificationCount(this.unreadNotificationCount.getValue() + amount);
  }

  decrementUnreadNotificationCount(amount = 1) {
    this.setUnreadNotificationCount(this.unreadNotificationCount.getValue() - amount);
  }

  refreshUnreadNotificationCount() {
    this.http.get<{ count: number }>(urls.API_URL + urls.NOTIFICATIONS_UNREAD_COUNT_URL)
      .pipe(catchError(errorHandl))
      .subscribe({
        next: (data: any) => this.setUnreadNotificationCount(data?.count || 0),
        error: () => {}
      });
  }
}
